import { defineMessages, MessageDescriptor } from 'react-intl'
import { SelectionView } from '../types'

export const translationsProfile = defineMessages({
  overviewTitle: {
    id: 'profile.overview.title',
    defaultMessage: 'Profile',
  },
  list: {
    id: 'timeTracking.selectionView.list',
    defaultMessage: 'List',
  },
  qrCodeScanner: {
    id: 'timeTracking.selectionView.qrCodeScanner',
    defaultMessage: 'QR Code Scanner',
  },
  editProfileTitle: {
    id: 'profile.edit.title',
    defaultMessage: 'Edit Profile',
  },
})

export function translationsTimeTrackingSelection(
  view: SelectionView
): MessageDescriptor {
  switch (view) {
    case SelectionView.LIST:
      return translationsProfile.list
    case SelectionView.QR_CODE_SCANNER:
      return translationsProfile.qrCodeScanner
  }
}
